import i18n from "@breward/i18n";

export const CONTEST_TYPES = {
  homebrew: {
    label: "global:shared.ContestType.Homebeer",
  },
  commercial: {
    label: "global:shared.ContestType.Commercial",
  },
  hybrid: {
    label: "global:shared.ContestType.Hybrid",
  },
};

export const CONTESTS_STATES = {
  draft: {
    label: "global:shared.ContestState.Draft",
    color: "disabled",
  },
  published: {
    label: "global:shared.ContestState.Published",
    color: "success",
  },
  registering: {
    label: "global:shared.ContestState.Registering",
    color: "info",
  },
  storing_entries: {
    label: "global:shared.ContestState.StoringEntries",
    color: "info",
  },
  in_progress: {
    label: "global:shared.ContestState.InProgress",
    color: "warning",
  },
  finished: {
    label: "global:shared.ContestState.Finished",
    color: "success",
  },
  cancelled: {
    label: "global:shared.ContestState.Cancelled",
    color: "error",
  },
};

export const CHECKLIST_ITEMS = {
  locationFilled: {
    order: 1,
    label: "global:shared.ChecklistItems.locationFilled",
    link: "/settings/info",
  },
  scheduleFilled: {
    order: 2,
    label: "global:shared.ChecklistItems.scheduleFilled",
    link: "/settings/info",
  },
  stylesAssigned: {
    order: 3,
    label: "global:shared.ChecklistItems.stylesAssigned",
    link: "/settings/styles",
  },
  scoresheetSchemasAssigned: {
    order: 4,
    label: "global:shared.ChecklistItems.scoresheetSchemasAssigned",
    link: "/settings/judging",
  },
  stagesAssigned: {
    order: 5,
    label: "global:shared.ChecklistItems.stagesAssigned",
    link: "/settings/stages",
  },
  paymentsSetupCompleted: {
    order: 6,
    label: "global:shared.ChecklistItems.paymentsSetupCompleted",
    link: "/settings/entries",
  },
};

export const STAGE_TYPES = [
  {
    label: i18n.t("global:shared.StageType.Calibration", "Calibration"),
    value: "calibration",
  },
  {
    label: i18n.t("global:shared.StageType.Regular", "Regular / Elimination"),
    value: "regular",
  },
  {
    label: i18n.t("global:shared.StageType.Finals", "Final / MiniBOS"),
    value: "finals",
  },
  {
    label: i18n.t("global:shared.StageType.BOS", "Grand Prix / BOS"),
    value: "bos",
  },
];

export const STAGE_TYPE_ORDER = {
  calibration: 0,
  regular: 1,
  finals: 2,
  bos: 3,
};
